import React from "react";
import Button from "@material-ui/core/Button";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import FilterListIcon from "@material-ui/icons/FilterList";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import {
  clearNutritionalFact,
  clearPriceRange,
  clearSortBy,
  deleteAvailableProduct,
  deleteCategory,
  deleteFilter,
  fetchFilters,
} from "../../../store/actions/productFilter";
import { getSortTranslation, isEqual } from "./helper";

const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};
const FilterTag = ({ name, filterName, filterArName, onDelete, arName }) => {
  const language = useSelector((state) => state.store.language);

  const capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  };
  let displayFilterName = `${capitalize(
    language === "arabic" ? filterArName : filterName
  )}: ${capitalize(language === "arabic" ? arName : name)}`;

  if (filterName === "Available Products") {
    displayFilterName = `${capitalize(
      language === "arabic" ? filterArName : filterName
    )} ${capitalize(language === "arabic" ? arName : name)}`;
  }

  if (filterName === "Nutritional Fact") {
    displayFilterName = `${capitalize(
      language === "arabic" ? filterArName : filterName
    )}`;
  }

  return (
    <div
      style={{
        height: 35.44,
        padding: "6px 8px",
        color: "#333333",
        backgroundColor: "#FFF",
        border: "1px solid #DEDEDE",
        borderRadius: 3,
        textTransform: "none",
        boxShadow: "none",
        marginLeft: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        whiteSpace: "nowrap",
        flexDirection: language === "arabic" ? "row-reverse" : "row",
      }}
    >
      <span
        style={{
          fontWeight: "bold",
          direction: language === "arabic" ? "rtl" : "ltr",
          display: "flex",
        }}
      >
        {displayFilterName}
        {filterName === "Nutritional Fact" ? name : ""}
      </span>
      <CloseIcon
        onClick={onDelete}
        style={{
          fontSize: 12,
          cursor: "pointer",
          marginLeft: language === "arabic" ? 0 : 25,
          marginRight: language === "arabic" ? 25 : 0,
          fontWeight: "bold",
        }}
      />
    </div>
  );
};

const FilterHeader = ({
  checkIfAnyFilterApplied,
  handleFilterDrawerToggle,
}) => {
  const filtersSelected = useSelector(
    (state) => state.productFilter.filtersSelected
  );
  const sortBy = useSelector((state) => state.productFilter.sortBy);
  const priceRange = useSelector(
    (state) => state.productFilter.priceRange.range
  );
  const selectedCategories = useSelector(
    (state) => state.productFilter.selectedCategories
  );
  const availableProducts = useSelector(
    (state) => state.productFilter.availableProducts
  );
  const nutritionalFact = useSelector(
    (state) => state.productFilter.nutritionalFact
  );
  const nutritionalFactMaxMin = useSelector(
    (state) => state.productFilter?.allProductNutritionFact
  );
  const allProductPriceRange = useSelector(
    (state) => state.productFilter?.allProductPriceRange
  );
  const storeFilters = useSelector(
    (state) => state.productFilter?.storeFilters
  );
  const themeColor = useSelector((state) => state.store.store.settings?.dark);
  const categories = useSelector((state) => state.store.store.categories);

  const dispatch = useDispatch();
  const language = useSelector((state) => state.store.language);
  //keep track of count filtered applied
  const [count, setCount] = React.useState(0);

  const filterChips = filtersSelected.map((filter) => (
    <FilterTag
      name={filter.filterOptionName}
      arName={filter.filterOptionArName}
      filterName={filter.filterName}
      filterArName={filter.filterArName}
      onDelete={() => dispatch(deleteFilter(filter.value, count))}
    />
  ));

  const sortChips = (
    <FilterTag
      name={sortBy.filterOptionName}
      arName={getSortTranslation(sortBy.filterOptionName)}
      filterName={sortBy.filterName}
      filterArName={"الترتيب"}
      onDelete={() => dispatch(clearSortBy())}
    />
  );

  const priceChips = (
    <FilterTag
      filterName={"Price"}
      filterArName={"السعر"}
      name={`${priceRange?.[0]} - ${priceRange?.[1]}`}
      arName={`${priceRange?.[0]} - ${priceRange?.[1]}`}
      onDelete={() => dispatch(clearPriceRange(count))}
    />
  );

  const checkNutritionalFact = () => {
    return isEqual(nutritionalFact, {
      calories: null,
      carbs: null,
      fats: null,
      protein: null,
      dietaryRestrictions: [],
    });
  };

  const nutritionalFactChips = (
    <FilterTag
      filterName={"Nutritional Fact"}
      filterArName={"القيمة الغذائية"}
      onDelete={() => dispatch(clearNutritionalFact(count))}
    />
  );

  const categoryChips = categories
    .filter((category) => selectedCategories.includes(category.id))
    .map((category) => (
      <FilterTag
        filterArName={"الصنف"}
        filterName={"Category"}
        arName={category.ar_name}
        name={category.name}
        onDelete={() => dispatch(deleteCategory(category.id, count))}
      />
    ));

  const availableProductsChip = (
    <FilterTag
      filterName={"Available Products"}
      filterArName={"المنتجات المتاحة"}
      onDelete={() => dispatch(deleteAvailableProduct(count))}
    />
  );

  React.useEffect(() => {
    let count = 0;
    if (filtersSelected.length > 0) {
      count += filtersSelected.length;
    }
    if (sortBy.value !== "") {
      count += 1;
    }
    if (priceRange !== null && priceRange.length > 0) {
      count += 1;
    }
    if (selectedCategories.length > 0) {
      count += selectedCategories.length;
    }
    if (availableProducts) {
      count += 1;
    }
    if (!checkNutritionalFact()) {
      count += 1;
    }
    setCount(count);
  }, [
    filtersSelected,
    sortBy,
    priceRange,
    selectedCategories,
    availableProducts,
    nutritionalFact,
  ]);

  const checkFetchFilter =
    !nutritionalFactMaxMin || !allProductPriceRange || !storeFilters;

  return (
    <div
      className={"hide-scrollbar"}
      style={{
        display: "flex",
        justifyContent: checkIfAnyFilterApplied() ? "" : "space-between",
        alignItems: "center",
        padding: "0 11px",
        marginBottom: 19,
        overflowX: "scroll",
        overflowY: "hidden",
        whiteSpace: "nowrap",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        flexDirection: language === "arabic" ? "row-reverse" : "row",
      }}
    >
      <div
        style={{
          marginLeft: language === "arabic" ? 10 : 0,
        }}
      >
        <Button
          style={{
            color: checkIfAnyFilterApplied() ? "#FFF" : "#333333",
            backgroundColor: checkIfAnyFilterApplied() ? themeColor : "#FFF",
            border: "1px solid #DEDEDE",
            borderRadius: 3,
            textTransform: "none",
            boxShadow: "none",
            fontWeight: "bold",
            fontSize: 12,
            width: "100%",
          }}
          onClick={() => {
            handleFilterDrawerToggle(true);
            if (true || checkFetchFilter) {
              dispatch(fetchFilters());
            }
          }}
        >
          {language === "arabic" ? "التصفية و الترتيب" : "Filter & Sort"}
        </Button>
      </div>
      {checkIfAnyFilterApplied() ? (
        <div
          style={{
            display: "flex",
          }}
        >
          {categoryChips.length !== 0 ? categoryChips : null}
          {sortBy.value !== "" ? sortChips : null}
          {priceRange !== null ? priceChips : null}
          {filterChips.length !== 0 ? filterChips : null}
          {availableProducts ? availableProductsChip : null}
          {!isEqual(nutritionalFact, {
            calories: null,
            carbs: null,
            fats: null,
            protein: null,
            dietaryRestrictions: [],
          })
            ? nutritionalFactChips
            : null}
        </div>
      ) : (
        <div
          onClick={() => {
            handleFilterDrawerToggle(true);
            if (checkFetchFilter) {
              dispatch(fetchFilters());
            }
          }}
          style={{
            cursor: "pointer",
          }}
        >
          <ImportExportIcon
            color={"rgba(0, 0, 0, 0.54)"}
            style={{
              fontSize: 20,
              marginRight: 3,
            }}
          />
          <FilterListIcon
            color={"rgba(0, 0, 0, 0.54)"}
            style={{
              fontSize: 20,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default FilterHeader;
